
































































import 'vue-awesome/icons/exclamation-triangle'
import 'vue-awesome/icons/thumbs-up'

export default
  name: 'Forecast'
  components: `{
    balance: require('components/inside/elements/balance.vue').default,
    forecast_modal: () => import(/* webpackChunkName: "forecast_modal" */'components/inside/elements/forecast_modal.vue')
  }`
  data: ->
    forecast_chart_visible: false
  computed:
    rs_balance: -> @$store.getters.rs.balance
    forecast: -> @$store.getters.forecast
    minimum_day: -> @forecast.minimum_day
    surplus_amount: ->
      diff = @minimum_day?.reserves_balance || 0
      diff = 0 if Math.abs(diff) < Math.abs(@rs_balance / 100)
      @$store.state.ui.forecast.surplus_amount = diff
      return diff
  mounted: ->
    event = "keyup.show_forecast"
    $(window).off(event).on event, (e) =>
      if e.keyCode == 88 && e.altKey == true
        return if $('textarea:focus').length > 0
        return if $('input:focus').length > 0
        @forecast_chart_visible = !@forecast_chart_visible
  methods:
    displayForecastModal: ->
      @forecast_chart_visible = true
      HM.track "forecast-viewed", { surplus: @$store.getters.forecast }
